export class LocalStorage {
  public static readonly token: string = 'token';
  public static readonly session: string = 'session';
  public static readonly i18nextLng: string = 'i18nextLng';

  public static get(key: string) {
    return localStorage.getItem(key);
  }

  public static set(key: string, value: string) {
    return localStorage.setItem(key, value);
  }

  public static remove(key: string) {
    return localStorage.removeItem(key);
  }
}

export const TOKEN_MIGRATION_KEY = 'token-migration';
export const TOKEN_MIGRATION_VERSION = '2';

const MIGRATED_KEYS: string[] = [LocalStorage.token, LocalStorage.session];

export type TokenMigrationResult = {
  migrated: boolean;
  fromVersion: string | null;
  toVersion: string;
  clearedKeys: string[];
};

/**
 * Eski formatlı token/session kayıtlarını tarayıcıdan bir kez temizler.
 * Flag versiyonlu tutulur; ileride yeni bir migration gerektiğinde
 * TOKEN_MIGRATION_VERSION artırılır ve temizlik tekrar çalışır.
 */
export function clearTokensOnce(): TokenMigrationResult {
  const fromVersion = LocalStorage.get(TOKEN_MIGRATION_KEY);

  if (fromVersion === TOKEN_MIGRATION_VERSION) {
    return {
      migrated: false,
      fromVersion,
      toVersion: TOKEN_MIGRATION_VERSION,
      clearedKeys: [],
    };
  }

  const clearedKeys = MIGRATED_KEYS.filter(
    (key) => LocalStorage.get(key) !== null
  );
  clearedKeys.forEach((key) => LocalStorage.remove(key));
  LocalStorage.set(TOKEN_MIGRATION_KEY, TOKEN_MIGRATION_VERSION);

  return {
    migrated: true,
    fromVersion,
    toVersion: TOKEN_MIGRATION_VERSION,
    clearedKeys,
  };
}
